import { useEffect } from 'react';

import type { RefObject } from 'react';

const useScrollToggle = <TElement extends HTMLElement>({
  targetRef,
  scrolledClassName = 'scrolled',
  disabled = false,
}: {
  targetRef: RefObject<TElement | null>;
  scrolledClassName?: string;
  disabled?: boolean;
}) => {
  useEffect(() => {
    if (disabled) return () => null;

    const element = targetRef.current;
    if (!element) return () => null;

    const updateScrollState = (): void => {
      const isScrolled = window.scrollY > 0;
      element.classList.toggle(scrolledClassName, isScrolled);
    };

    updateScrollState();

    window.addEventListener('scroll', updateScrollState);

    return () => {
      window.removeEventListener('scroll', updateScrollState);
      element.classList.remove('scrolled');
    };
  }, [disabled, targetRef]);
};

export { useScrollToggle };
